<template>
  <div class="legaldisclaimer-view">
    <h1 class="agreement-title">法律声明</h1>
    <div class="agreement-content">
      <div class="agreement-content-text">
        <p>本法律声明适用于显示本法律声明、或链接至本法律声明的易软信息科技（惠州）有限公司（下文简称“易趣团队”）的网站和服务。使用本网站前请您仔细阅读以下条款。使用本网站则表明您已明知并接受这些条款。如果不接受这些条款请不要使用本网站。</p>
        <h3>1. 网站的使用</h3>
        <p>易趣团队拥有易趣软件网站内所有信息内容的著作权、商标权、专利权等知识产权。易趣团队网站上的内容，仅供浏览者用于个人非商业用途。您不得以任何方式修改、复制、公开展示、公布或分发这些材料或者以其他方式把它们用于任何公开或商业目的。禁止以任何目的把这些材料用于其他任何网站或其他平面媒体或网络计算机环境。易趣软件网站内容均受著作权法和国际公约等法律保护，任何未经授权的使用都可能构成对著作权权、商标和其他法律权利的侵犯。</p>
        <p>易趣软件网站所有的产品、技术与所有程序均属于易趣团队或者合作第三方的知识产权。产品服务名称及相关图形、标识等为易趣团队的注册商标。未经易趣团队许可，任何人不得擅自（包括但不限于：以非法的方式复制、传播、展示、镜像、上载、下载）使用。否则，易趣团队将依法追究法律责任。</p>
        <h3>2. 信息发布</h3>
        <p>易趣软件网站的信息按原样提供，不附加任何形式的保证，包括适销性、适合于特定目的或不侵犯知识产权的保证。此外，易趣团队也不保证本站信息的绝对准确性和绝对完整性。易趣软件网站中的内容或在这些内容中介绍的产品、价格和配置等会随时变更，恕不另行通知。本站中的内容也可能已经过期，易趣团队不承诺更新它们。本站发布的信息可能是在您本地尚不能得到的产品、程序或服务，您可向易趣团队客服咨询。</p>
        <h3>3. 关于用户帐户和个人资料</h3>
        <p>除个人识别信息，其他任何您发送或邮寄给本站的材料、信息或联系方式(以下统称信息)均将被视为非保密和非专有。易趣团队将对这些信息不承担任何义务。同时您的提交行为如果没有特别声明时，可视为同意（或授权）：易趣团队及其授权人将可因商业或非商业的目的自由复制、透露、分发、合并和以其他方式利用这些信息和所有数据、图像、声音、文本及其他内容。</p>
        <p>除个人识别信息，其他任何您发送或邮寄给本站的材料、信息或联系方式(以下统称信息)均将被视为非保密和非专有。易趣团队将对这些信息不承担任何义务。同时您的提交行为如果没有特别声明时，可视为同意（或授权）：易趣团队及其授权人将可因商业或非商业的目的自由复制、透露、分发、合并和以其他方式利用这些信息和所有数据、图像、声音、文本及其他内容。
            您不得以虚假、伪装、或冒充他人身份的方式访问本网站。如果网站某些部分需要您建立帐户或设定个人信息，您提供的信息必须真实可靠。您同意确保帐户信息的安全和保密，不得让他人使用您的帐户、配置文件、软件，否则您可能需为易趣团队以及本网站的任何其他用户或访客由此而遭受的损失承担责任。易趣团队可以自行决定是否拒绝、删除您发布的任何内容，限制、暂停、或终止您对网站的访问，且有权保留或删除您提供的任何信息或内容。</p>
        <h3>4. 用户交流内容</h3>
        <p>易趣团队不负监控或审查用户在本站上发送或邮寄的信息或相互之间单独交流的任何领域信息的责任，包括但不限于交谈室、公告牌或其他用户论坛以及任何交流内容。易趣团队对有关任何这类交流的内容不承担任何责任，无论它们是否会引起诽谤、隐私、淫秽或其它方面的问题。易趣团队保留在发现时删除包含被视为侮辱、诽谤、淫秽或其它不良内容的信息消息的权利。</p>
        <h3>5. 本站下载软件的使用</h3>
        <p>如果您从本站下载软件，在使用软件时要遵守该软件携带的软件许可协议中所有的许可条款。在您阅读并接受软件许可协议的各项条款之前，不得下载或安装这一软件。</p>
        <h3>6. 链接第三方网站</h3>
        <p>本站到第三方网站的链接仅作为一种方便服务提供给您。如果使用这些链接，您将离开本站。易趣团队没有审查过任何第三方网站，对这些网站及其内容不进行控制，也不负任何责任。如果您决定访问任何与本站链接的第三方网站，其可能带来的结果和风险全部由您自己承担。</p>
        <h3>7. 责任限制</h3>
        <p>易趣团队及其供应商或本站中提到的第三方对任何损害概不负责（包括但不限于由损失的利润、损失的数据或业务中断而造成的损害），无论这些损害是否由于使用、或不能使用本站的结果、与本站链接的任何网站或者任何这类网站中包含的信息所引起，也不管它们是否有保证、合同、侵权行为或任何其它法律根据以及事前已得到这类损害可能发生的忠告。如果您由于使用本站的信息而导致需要对设备或数据进行维护、修理或纠正，您应意识到须自行承担必须承担由此而造成的所有费用。</p>
        <h3>8. 其他条款</h3>
        <p>1）易趣团队可能随时修改这些条款。您应经常访问本页面以了解当前的条款，因为这些条款与您密切相关。这些条款的某些条文也可能被本站中某些页面上明确指定的法律声明或条款所取代。</p>
        <p>2）易趣团队的隐私政策亦适用于易趣软件网站的使用。使用易趣软件网站，即表示您确认并同意易趣团队可以根据此隐私政策使用此类信息。</p>
        <p>3）因本声明或使用本网站所发生的争议适用中华人民共和国法律。</p>
        <p>4）因本声明或使用本网站发生争议，应当协商解决，协商不成的，各方一致同意由易趣团队所在地有管辖权的人民法院诉讼解决。</p>
        <p>5）本声明的解释权及对本网站使用的解释权归于易趣团队。</p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.legaldisclaimer-view {
  width: 1200px;
  margin: 0 auto;
  min-height: 50vh;
  margin-top: 40px;
  margin-bottom: 80px;

  .agreement-title {
    text-align: center;
    text-wrap-mode: wrap;
    text-align: center;
    margin-top: 15px;
  }

  .agreement-content {
    text-wrap-mode: wrap;
    text-align: justify;

    p {
      font-size: 18px;
      line-height: 30px;
      margin-bottom: 18px;
      margin-top: 18px;
    }
  }
}

</style>

<script lang="ts" setup>
/* definePageMeta()是编译器宏，不用实际代码运行 */
definePageMeta({
})
</script>

